import PropTypes from 'prop-types';
import { CheckMarkIcon } from './icons';

/**
 * Square checkbox sized to match a standard 40px field, so checklist rows line
 * up with the inputs beside them. Black when checked, white otherwise.
 */
export const CHECKBOX_CLASS =
  'flex h-10 w-10 shrink-0 items-center justify-center rounded-input border border-shoorah-borderGray dark:border-shoorah-darkBorder transition-colors';

// Compact variant for dense lists such as the dashboard preview.
const CHECKBOX_CLASS_SM =
  'flex h-6 w-6 shrink-0 items-center justify-center rounded-input border border-shoorah-borderGray dark:border-shoorah-darkBorder transition-colors';

const ChecklistCheckbox = ({ checked, onToggle, disabled = false, label, size = 'md' }) => (
  <button
    type="button"
    role="checkbox"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={onToggle}
    className={`${size === 'sm' ? CHECKBOX_CLASS_SM : CHECKBOX_CLASS} ${
      checked
        ? 'bg-shoorah-btn border-shoorah-btn'
        : 'bg-white dark:bg-shoorah-darkBgColor hover:border-shoorah-btn dark:hover:border-shoorah-btnDark'
    } ${disabled ? 'cursor-not-allowed opacity-60' : ''}`}
  >
    {checked && (
      <CheckMarkIcon className={size === 'sm' ? 'w-3 h-3 text-white' : 'w-4 h-4 text-white'} />
    )}
  </button>
);

ChecklistCheckbox.propTypes = {
  checked: PropTypes.bool,
  onToggle: PropTypes.func,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md'])
};

export default ChecklistCheckbox;
